/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Grid } from '@mui/material';

const style = {
  border: '1px solid rgba(255, 255, 255, 0.3)',
  borderRadius: '5px',
  px: 3,
  py: 2,
};

const hoursStyle = {
  bgcolor: '#84d8c5',
  borderRadius: '5px',
  textAlign: 'center',
  py: 0.2,
  mt: 2,
};

export const ProjectCard = (props) => {
  return (
    <Grid item xs={6}>
      <Grid sx={style}>
        <Typography sx={{ fontWeight: 600 }} margin={0} variant="h6">
          {props.title}
        </Typography>
        <Grid item>
          <Typography variant="caption">{props.desc}</Typography>
        </Grid>
        <Grid item xs={12} sx={hoursStyle}>
          <Typography fontWeight={600} variant="subtitle1">
            {props.hours} HOURS
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
